import { useQuery } from "react-query";
import { getManageableListItem } from "../api/getManageableListItem";
import { API_KEY_GET_MANAGEABLE_LIST_ITEM } from "../constants";

export const useGetManageableListItem = (id) => {
  return useQuery([API_KEY_GET_MANAGEABLE_LIST_ITEM, id], () =>
    getManageableListItem(id)
  );
};
